import { Injectable } from "@angular/core";
import { UserService } from "../user.service";
import { Router } from "@angular/router";
import { io } from "socket.io-client";

import { environment } from "../../../../../environments/environment";
import { RouteEventsService } from "./route-events.service";

/* Source: https://codeburst.io/react-authentication-with-twitter-google-facebook-and-github-862d59583105 */

@Injectable()
export class SocketService {
  private socket;

  constructor(
    private router: Router,
    private routeEventsService: RouteEventsService,
    private userService: UserService
  ) {}

  ngOnInit() {}

  public connect() {
    const api_url = environment.api_url;
    const socketURL = api_url.slice(0, api_url.lastIndexOf("/"));

    this.socket = io(socketURL, {
      withCredentials: true,
    });
    this.socket.on("connect", () => {});

    this.socket.on("authUser", (data) => {
      this.userService.deleteUser();
      this.userService.setAuth(data.user);
      this.disconnect();
      this.onSkipHandler();
    });
  }

  public disconnect() {
    this.socket.emit("end");
  }

  /* navigate the user to where they came from */
  public onSkipHandler() {
    window.location.reload();
    //this.router.navigate([this.routeEventsService.previousRoutePath.value]);
  }
}
